export const ROTATION_OPTIONS = Object.freeze({
  OPTIMIZED_FOR_CLICKS: 'OptimizeForClicks',
  ROTATE_ADS_EVENLY: 'RotateAdsEvenly',
});

export const ROTATION_OPTION_TO_TEXT = Object.freeze({
  [ROTATION_OPTIONS.OPTIMIZED_FOR_CLICKS]: _TL_('Optimize - prioritize ads that perform well'),
  [ROTATION_OPTIONS.ROTATE_ADS_EVENLY]: _TL_('Rotate ads more evenly - include all ads, even those with a lower CTR'),
});

export const RotationItems = [
  { id: ROTATION_OPTIONS.OPTIMIZED_FOR_CLICKS, text: ROTATION_OPTION_TO_TEXT[ROTATION_OPTIONS.OPTIMIZED_FOR_CLICKS] },
  { id: ROTATION_OPTIONS.ROTATE_ADS_EVENLY, text: ROTATION_OPTION_TO_TEXT[ROTATION_OPTIONS.ROTATE_ADS_EVENLY] },
];
